import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { AdminHeader } from "./AdminLayout";

export default function AdminAuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then(r => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <AdminHeader title="Audit Logs" subtitle="Staff activity trail" />
      <div className="bg-white border border-sage/30 rounded-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-sage/30 text-left text-forest/50 text-xs uppercase"><th className="p-3">Actor</th><th className="p-3">Role</th><th className="p-3">Action</th><th className="p-3">Entity</th><th className="p-3">When</th></tr></thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-sage/15">
                <td className="p-3">{l.actor}</td><td className="p-3 text-forest/50">{l.actor_role}</td>
                <td className="p-3 capitalize">{l.action}</td><td className="p-3">{l.entity} <span className="text-forest/40">{l.entity_id?.slice(0, 8)}</span></td>
                <td className="p-3 text-forest/50">{new Date(l.at).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
